import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import "./tenant-details-right-panel.scss";
import TenantBesicDetails from "./tenant-basic-details/tenant-basic-details";
import TenantPlanDetails from "./tenant-plan-details/tenant-plan-details";
import TenantUserDetails from "./tenant-user-details/tenant-user-details";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../constants/routes";

interface RightTenantDetailsPanelProps {
  tenantData: any;
  tenetRoles: any;
  setTenantData: any;
  partnerDetails: any;
  defaultTabIndex?: number;
}

const RightTenantDetailsPanel: React.FC<RightTenantDetailsPanelProps> = ({
  tenantData,
  tenetRoles,
  setTenantData,
  partnerDetails,
  defaultTabIndex,
}) => {
  const [indexValue, setIndexValue] = React.useState(defaultTabIndex ?? 0);
  const navigate = useNavigate();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setIndexValue(newValue);
  };

  const handleLogButton = () => {
    navigate(routes.PARTNERLEADSLOG, {
      state: {
        tenantData: tenantData,
      },
    });
  };

  const renderTabContent = () => {
    switch (indexValue) {
      case 0:
        return (
          <TenantBesicDetails
            tenantData={tenantData}
            setTenantData={setTenantData}
          />
        );
      case 1:
        return <TenantPlanDetails tenantData={tenantData} />;
      case 2:
        return (
          <TenantUserDetails
            tenantData={tenantData}
            tenetRoles={tenetRoles}
            setTenantData={setTenantData}
            partnerDetails={partnerDetails}
          />
        );
      default:
        return (
          <TenantBesicDetails
            tenantData={tenantData}
            setTenantData={setTenantData}
          />
        );
    }
  };

  return (
    <Box>
      <Box className="tenant-details-right-panel-tab">
        <Tabs
          value={indexValue}
          onChange={handleTabChange}
          allowScrollButtonsMobile
          scrollButtons
          variant="scrollable"
          sx={{
            "& .MuiTabs-scrollButtons": {
              width: 32, // or your preferred size
            },
          }}
        >
          <Tab iconPosition="start" label="Basic Details " />
          <Tab iconPosition="start" label="Plans" />
          <Tab iconPosition="start" label="Users" />
        </Tabs>
        <button className="leads-log-btn" onClick={handleLogButton}>
          Leads Log
        </button>
      </Box>
      <Box>{renderTabContent()}</Box>
    </Box>
  );
};

export default RightTenantDetailsPanel;
